import { create } from 'zustand';
export const useDismissedUpsellsStore = create((set) => ({
    userId: null,
    dismissedNames: new Set(),
    markDismissed: (userId, upsellName) => set((state) => state.userId === userId
        ? { ...state, dismissedNames: new Set(state.dismissedNames).add(upsellName) }
        : { userId, dismissedNames: new Set([upsellName]) }),
}));
export const isUpsellDismissed = (upsellName, currentUserId, state) => {
    if (!upsellName)
        return false;
    if (state.userId !== currentUserId)
        return false;
    return state.dismissedNames.has(upsellName);
};
//# sourceMappingURL=useDismissedUpsellsStore.js.map